"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
require("core-js/modules/es.object.get-prototype-of.js");
require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.calculateErrors = void 0;
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.match.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.object.to-string.js");
var _react = _interopRequireDefault(require("react"));
var _FormControls = require("../../FormControls");
var _semanticUiReact = require("semantic-ui-react");
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var calculateErrors = function calculateErrors(password, confirmation) {
  var newErrors = {
    password: '',
    confirmation: ''
  };
  if (password !== confirmation) {
    newErrors.confirmation = 'Your password and confirm password must match';
  }
  if (password === undefined || password.length < 15 || password.length > 64) {
    newErrors.password = 'Your password must be between 15 and 64 characters';
  } else if (!password.match(/[a-z]/)) {
    newErrors.password = 'Your password must contain at least 1 lowercase letter';
  } else if (!password.match(/[A-Z]/)) {
    newErrors.password = 'Your password must contain at least 1 uppercase letter';
  } else if (!password.match(/[0-9]/)) {
    newErrors.password = 'Your password must contain at least 1 number';
  } else if (!password.match(/[ !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]+/)) {
    newErrors.password = 'Your password must contain at least 1 special character';
  }
  return newErrors;
};
exports.calculateErrors = calculateErrors;
var CreatePasswordForm = /*#__PURE__*/function (_React$Component) {
  _inherits(CreatePasswordForm, _React$Component);
  var _super = _createSuper(CreatePasswordForm);
  function CreatePasswordForm(props) {
    var _this;
    _classCallCheck(this, CreatePasswordForm);
    _this = _super.call(this, props);
    _this.handleChange = function (e) {
      var _e$target = e.target,
        name = _e$target.name,
        value = _e$target.value;
      _this.props.handleChange(name, value);
    };
    _this.handleBlur = function (e) {
      var _e$target2 = e.target,
        name = _e$target2.name,
        value = _e$target2.value;
      var newBlurred = Object.assign({}, _this.state.blurred);
      newBlurred[name] = true;
      _this.setState({
        blurred: newBlurred
      });
    };
    _this.displayErrorsForField = function (fieldName) {
      return _this.state.errors[fieldName];
    };
    _this.state = {
      blurred: {
        password: false,
        confirmation: false
      },
      errors: {
        password: '',
        confirmation: ''
      }
    };
    return _this;
  }
  _createClass(CreatePasswordForm, [{
    key: "render",
    value: function render() {
      var blurred = this.state.blurred;
      var _this$props = this.props,
        password = _this$props.password,
        confirmation = _this$props.confirmation;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Divider, null), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", null, "Your password must be between 15 and 64 characters."), /*#__PURE__*/_react.default.createElement("p", null, "Your password must contain:"), /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, "1 lowercase letter"), /*#__PURE__*/_react.default.createElement("li", null, "1 uppercase letter"), /*#__PURE__*/_react.default.createElement("li", null, "1 number"), /*#__PURE__*/_react.default.createElement("li", null, "1 special character"))), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Form.Field, null, /*#__PURE__*/_react.default.createElement(_FormControls.TextBoxField, {
        value: password,
        label: "Password",
        id: "password",
        title: 'Required: Password',
        name: "password",
        displayError: blurred.password && this.displayErrorsForField('password'),
        handleChange: this.handleChange,
        handleBlur: this.handleBlur,
        maxLength: 65,
        type: "password",
        errorMessages: this.displayErrorsForField('password')
      })), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Form.Field, null, /*#__PURE__*/_react.default.createElement(_FormControls.TextBoxField, {
        value: confirmation,
        label: "Confirm Password",
        id: "confirmation",
        title: 'Required: confirmation',
        name: "confirmation",
        displayError: blurred.confirmation && this.displayErrorsForField('confirmation'),
        handleChange: this.handleChange,
        handleBlur: this.handleBlur,
        maxLength: 65,
        type: "password",
        errorMessages: this.displayErrorsForField('confirmation')
      })));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var newState = Object.assign({}, prevState);
      var password = nextProps.password,
        confirmation = nextProps.confirmation;
      newState.errors = calculateErrors(password, confirmation);
      var hasErrors = _lodash.default.some(newState.errors, function (err) {
        return err !== undefined && err.length > 0;
      });
      nextProps.handlePasswordErrors(hasErrors);
      // calculate validations and errors in here, values come as props
      return newState;
    }
  }]);
  return CreatePasswordForm;
}(_react.default.Component);
exports.default = CreatePasswordForm;